var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#867659",
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.878 24.462c.337-1.382 1.988-.978 1.785.202v.002c-2.123 8.728-9.976 15.2-19.312 15.2C9.398 39.866.5 30.967.5 20.013S9.398.163 20.351.163c9.37 0 17.223 6.504 19.313 15.2.169 1.314-1.55 1.348-1.787.202-1.955-7.82-9.066-13.616-17.492-13.616-9.975 0-18.064 8.089-18.064 18.064 0 9.976 8.088 18.065 18.064 18.065 8.427 0 15.504-5.797 17.492-13.616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.416 19.372.004-.006a1.11 1.11 0 0 0 .223 1.525c.173.143.41.234.683.234a1.112 1.112 0 0 0 .604-2.047 1.07 1.07 0 0 0-.604-.178c-.405 0-.742.203-.91.472m-16.312-3.977c-.235 0-.606.135-.606.674h.033v1.45h2.224l-.269 2.493h-1.988v7.044h-2.933v-7.044h-1.381v-2.46h1.381v-1.618c0-1.18.573-2.965 2.966-2.965h2.157v2.426z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h40v40H.5z"
  })))));
};
export default SvgFacebook;